import React from 'react';
import Container from './Container';

export interface SectionProps {
  /**
   * Section content
   */
  children: React.ReactNode;
  /**
   * Optional CSS class to add
   */
  className?: string;
  /**
   * Background color
   */
  bgColor?: string;
  /**
   * Section ID for navigation
   */
  id?: string;
  /**
   * Should section be contained
   */
  contained?: boolean;
  /**
   * Container size if contained
   */
  containerSize?: 'sm' | 'md' | 'lg' | 'xl' | 'full';
  /**
   * Vertical padding size
   */
  padding?: 'none' | 'sm' | 'md' | 'lg' | 'xl';
}

/**
 * Section component for page segmentation with consistent spacing
 */
export const Section: React.FC<SectionProps> = ({
  children,
  className = '',
  bgColor = '',
  id,
  contained = true,
  containerSize = 'lg',
  padding = 'lg',
  ...props
}) => {
  // Padding classes
  const paddingClasses = {
    none: '',
    sm: 'py-4 md:py-6',
    md: 'py-8 md:py-12',
    lg: 'py-12 md:py-16 lg:py-20',
    xl: 'py-16 md:py-24 lg:py-32',
  };

  // Combine section classes
  const sectionClasses = [
    bgColor,
    paddingClasses[padding],
    className,
  ].filter(Boolean).join(' ');

  return (
    <section id={id} className={sectionClasses} {...props}>
      {contained ? (
        <Container size={containerSize}>{children}</Container>
      ) : (
        children
      )}
    </section>
  );
};

export default Section;